module.exports = __webpack_public_path__ + "img/21-bd9ba5.png";